export enum OrderFrontStatus {
    validated = "validated",
    payed = "payed",
    preparation = "preparation",
    delivered = "delivered",
    refunded = "refunded",
    paiement_failed_can_not_resume = "paiement_failed_can_not_resume",
    paiement_failed_can_resume = "paiement_failed_can_resume",
    paiement_3ds = "paiement_3ds",
    canceled_can_resume = "canceled_can_resume",
    canceled_can_not_resume = "canceled_can_not_resume",
}

export enum PriceCategory {
    priceOneShot = "priceOneShot",
    priceOneShotEnterprise = "priceOneShotEnterprise",
    priceSubscription = "priceSubscription",
    priceSubscriptionEnterprise = "priceSubscriptionEnterprise",
}

export default {
    OrderFrontStatus,
    PriceCategory,
}
